export const MAIN = "MAIN";
export const MAIN_SET_CONTEXT = `${MAIN}_SET_CONTEXT`;
export const MAIN_DRAW_REQUEST = `${MAIN}_DRAW_REQUEST`;
export const MAIN_DRAW_DONE = `${MAIN}_DRAW_DONE`;
export const MAIN_IMAGE_DATA_DONE = `${MAIN}_IMAGE_DATA_DONE`;

export const SATELLITE = "SATELLITE";
export const SATELLITE_SET_CONTEXT = `${SATELLITE}_SET_CONTEXT`;
export const SATELLITE_DRAW_REQUEST = `${SATELLITE}_DRAW_REQUEST`;
export const SATELLITE_DRAW_DONE = `${SATELLITE}_DRAW_DONE`;

export const ERROR = "ERROR";

export const WORKER = "WORKER";
export const WORKER_STOP = `${WORKER}_STOP`;
export const WORKER_START = `${WORKER}_START`;
export const WORKER_TERMINATE = `${WORKER}_TERMINATE`;
